export enum GridIds {
    SampleHistory = 'GLOBAL_SampleHistory'
}

export const LABID_PREFIX = 'LABID_';

export function getSampleGridIdForLab(labId: string): string {
    return `${LABID_PREFIX}${labId}`;
}
